import type { ReplyBarAsk } from "@omnabase/ui";

/** The reply bar's AI menu (the composer-and-fixes round, 2026-11-03; brief rule 4, the red team's findings 14 and 22). Pure. In this order, each
 *  with the letter that picks it while the menu is open:
 *  - **Write a draft** (no AI draft) or **Rewrite the draft** (with one), W in both states (the queue-and-chat-column round, 2026-11-03; P
 *    before): opens the prompt box; offered while the AI may be asked;
 *  - **Investigate the code**, I ("Investigating…" and off while one runs): offered when the ticket is investigable (a repository, or pages the
 *    customer linked), never on the sample ticket;
 *  - **Open in Claude**, O: while the member's own AI can reach the workspace.
 *  An empty list means no AI button. */
export type AskOptions = {
  prompt: { draft: boolean; onSelect: () => void } | null;
  investigation: { running: boolean; hover: string; onStart: () => void } | null;
  onOpenClaude: (() => void) | null;
};

export function replyBarAsks(o: AskOptions): ReplyBarAsk[] {
  return [
    ...(o.prompt ? [{ id: "prompt", label: o.prompt.draft ? "Rewrite the draft" : "Write a draft", key: "W", onSelect: o.prompt.onSelect }] : []),
    ...(o.investigation ? [{ id: "investigate", label: o.investigation.running ? "Investigating…" : "Investigate the code", key: "I", title: o.investigation.hover, disabled: o.investigation.running, onSelect: o.investigation.onStart }] : []),
    ...(o.onOpenClaude ? [{ id: "claude", label: "Open in Claude", key: "O", onSelect: o.onOpenClaude }] : []),
  ];
}

/** the ticket can be investigated: a repository for its project, or a page the customer linked (the page-look round) */
export const investigable = (i: { repo: string | null; pages: boolean } | null | undefined): boolean => !!i && (!!i.repo || i.pages);
